






























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BillData, BillItemData, BillItemGroup, BillSettings } from '@/models/billData';
import { BillTypes, getBillTypeName } from '@/enums/billTypes';
import BillGroupSelect, { BillGroupSelectItem } from '@/components/parts/billGroupSelect.vue';
import { KeyValuePair } from '@/models/keyValuePair';
import { BillItemGroupTypes, getBillItemGroupTypeName } from '@/enums/billItemGroupTypes';
import ElTableDraggable from 'element-ui-el-table-draggable';
import BigNumber from 'bignumber.js';
import { TaxTypes } from '@/enums/taxTypes';
import { TaxRoundTypes } from '@/enums/taxRoundTypes';
import { GradeYears } from '@/enums/gradeYears';
import { ElForm } from 'element-ui/types/form';
import * as billUtil from '@/utils/bill';
import { BillStatusTypes, getBillStatusTypeName } from '@/enums/billStatusTypes';
import moment from 'moment';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

interface Reflection {
  title: boolean;
  billDate: boolean;
  billMessage: boolean;
  contactInfo: boolean;
  billType: boolean;
  billExplanation: boolean;
  billLimitDate: boolean;
  taxRate: boolean;
  items: boolean;
}

export enum BillEditType {
  /** 請求書表示 */
  View,
  /** 請求書編集 */
  Edit,
  /** 請求書一括編集 */
  BulkEdit,
  /** 請求書表示 */
  PeriodicView,
  /** 定期請求書編集 */
  PeriodicEdit,
  /** 定期請求書編集 */
  PeriodicBulkEdit,
  /** 請求書テンプレート編集 */
  TemplateEdit,
}

@Component({
  components: {
    BillGroupSelect,
    ElTableDraggable,
  }
})
export default class BillEditor extends Vue {

  get isView() {
    return this.editType === BillEditType.View;
  }

  get isEdit() {
    return this.editType === BillEditType.Edit;
  }

  get isBulkEdit() {
    return this.editType === BillEditType.BulkEdit;
  }

  get isPeriodicView() {
    return this.editType === BillEditType.PeriodicView;
  }

  get isPeriodicEdit() {
    return this.editType === BillEditType.PeriodicEdit;
  }

  get isPeriodicBulkEdit() {
    return this.editType === BillEditType.PeriodicBulkEdit;
  }

  get isTemplateEdit() {
    return this.editType === BillEditType.TemplateEdit;
  }

  get masterGroups(): Array<KeyValuePair<BillItemGroupTypes, string>> {
    return this.billItems.reduce((list, item) => {
      if (!list.find((w) => w.key === item.groupType)) {
        list.push({
          key: item.groupType,
          value: getBillItemGroupTypeName(item.groupType),
        });
      }
      return list;
    }, new Array<KeyValuePair<BillItemGroupTypes, string>>());
  }

  get masterItems(): BillGroupSelectItem[] {
    return this.billItems.reduce((list, group) => {
      list.push(...group.billItems.map((item) => ({
        groupType: group.groupType,
        itemId: item.itemId,
        itemName: item.itemName,
        nonTaxable: item.nonTaxable,
      })));
      return list;
    }, new Array<BillGroupSelectItem>());
  }

  get taxRoundType(): BigNumber.RoundingMode {
    let roundType: BigNumber.RoundingMode = BigNumber.ROUND_HALF_UP;
    switch (this.billData.taxRoundType) {
      case TaxRoundTypes.HalfUp:
        roundType = BigNumber.ROUND_HALF_UP;
        break;
      case TaxRoundTypes.Up:
        roundType = BigNumber.ROUND_UP;
        break;
      case TaxRoundTypes.Down:
        roundType = BigNumber.ROUND_DOWN;
        break;
    }

    return roundType;
  }

  get subTotal() {
    let subTotal = new BigNumber(0);
    for (const item of this.billData.items) {
      const discount = new BigNumber(100).minus(item.discountOfPercent || 0).div(100);
      const price = new BigNumber(item.unitPrice).times(item.quantity).times(discount);
      subTotal = subTotal.plus(price);
    }
    return subTotal
      .dp(0, this.taxRoundType)
      .toNumber();
  }

  get tax(): number {
    let subTotalWithTax = new BigNumber(0);
    for (const item of this.billData.items) {
      if (item.nonTaxable) {
        continue;
      }
      const discount = new BigNumber(100).minus(item.discountOfPercent || 0).div(100);
      const price = new BigNumber(item.unitPrice).times(item.quantity).times(discount);
      subTotalWithTax = subTotalWithTax.plus(price);
    }

    if (this.billData.taxType === TaxTypes.Internal) {
      // 内税
      return subTotalWithTax
        .times(this.billData.taxRate)
        .div(100 + this.billData.taxRate)
        .dp(0, this.taxRoundType)
        .toNumber();
    } else {
      // 外税
      return subTotalWithTax
        .times(this.billData.taxRate)
        .div(100)
        .dp(0, this.taxRoundType)
        .toNumber();
    }
  }

  get total() {
    if (this.billData.taxType === TaxTypes.Internal) {
      // 内税
      return new BigNumber(this.subTotal)
        .toNumber();
    } else {
      // 外税
      return new BigNumber(this.subTotal)
        .plus(this.tax)
        .toNumber();
    }
  }

  get billStatusTypeDisplay() {
    const name = getBillStatusTypeName(this.billData.billStatus);
    switch (this.billData.billStatus) {
      case BillStatusTypes.Billed:
        return name;
    }

    return this.checkChargableBill(this.billData)
      ? `${name}(請求可)`
      : `${name}(請求不可)`;
  }

  get billStatusClass() {
    switch (this.billData.billStatus) {
      case BillStatusTypes.Billed:
        return 'bill-status-billed';
      case BillStatusTypes.Unbilled:
      default:
        return this.checkChargableBill(this.billData)
          ? 'bill-status-unbilled-chargable'
          : 'bill-status-unbilled-dischargable';
    }
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  public BillTypes = BillTypes;
  public getBillTypeName = getBillTypeName;
  public TaxTypes = TaxTypes;
  public getBillStatusTypeName = getBillStatusTypeName;

  @Prop({ type: Object, required: true })
  public billData!: BillData;

  @Prop({ type: Array, default: () => [] })
  public billItems!: BillItemGroup[];

  @Prop({ type: Number, required: true })
  public editType!: BillEditType;

  @Prop({ type: Number, default: false })
  public collectionAgency!: CollectionAgencyTypes;

  public reflection: Reflection = {
    title: false,
    billDate: false,
    billMessage: false,
    contactInfo: false,
    billType: false,
    billExplanation: false,
    billLimitDate: false,
    taxRate: false,
    items: false,
  };

  public refrectDetails() {
    this.billData.items.forEach((item) => {
      this.onChangeBillItem(item);
    });
  }

  public async validateBillData(): Promise<boolean> {
    const form = this.$refs.form as ElForm;

    return await new Promise((resolve) => {
      form.validate(async (valid) => {
        resolve(valid);
      });
    });
  }

  public clearValidateBillData() {
    const form = this.$refs.form as ElForm;
    form.clearValidate();
  }

  private checkChargableBill(billData: BillData) {
    if (billData.billStatus === BillStatusTypes.Billed) {
      return false;
    }

    if (!billData.billLimitDate) {
        // 決済日・支払期限が未設定
      return false;
    }

    const billLimitDate = moment(billData.billLimitDate).format('YYYYMMDD');
    const now = moment().format('YYYYMMDD');
    if (billLimitDate < now) {
        // 決済日・支払期限が請求日より古い
        return false;
    }

    return true;
  }

  @Watch('billData.billGradeYear', {immediate: true})
  private changeBillDataBillGradeYear() {
    this.billData.items.forEach((item) => {
      this.onChangeBillItem(item);
    });
  }

  private validateBillType(rule: any, value: BillTypes, callback: any) {
    if (value === BillTypes.None) {
      callback(new Error('お支払方法を選択してください'));
    } else {
      callback();
    }
  }

  private formatBillDate(row: BillData) {
    if (row.billDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billDateCreationMonth) {
      case 0:
        return `当月 ${row.billDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private formatBillLimitDate(row: BillData) {
    if (row.billLimitDateCreationMonth === null) {
      return '未指定';
    }

    switch (row.billLimitDateCreationMonth) {
      case 0:
        return `当月 ${row.billLimitDateCreationDay}日`;
      case 1:
        return `翌月 ${row.billLimitDateCreationDay}日`;
      case 2:
        return `翌々月 ${row.billLimitDateCreationDay}日`;
      default:
        return '未指定';
    }
  }

  private arraySpanMethod(
    { row, column, rowIndex, columnIndex }: { row: BillItemData, column: any, rowIndex: number, columnIndex: number}
  ) {
    if (row.isFree) {
      switch (column.property) {
        case 'groupType':
          return [1, 2];
        case 'itemId':
          return [0, 0];
      }
    }
  }

  private onAddBillItem() {
    this.billData.items.push({
      isFree: false,
      groupType: BillItemGroupTypes.TuitionFee,
      groupName: '',
      itemId: 0,
      itemName: '',
      unitPrice: 0,
      quantity: 1,
      discountOfPercent: 0,
      nonTaxable: false,
    });
    this.onGroupChange(this.billData.items[this.billData.items.length - 1]);
  }

  private onAddFreeBillItem() {
    this.billData.items.push({
      isFree: true,
      groupType: BillItemGroupTypes.TuitionFee,
      groupName: '',
      itemId: 0,
      itemName: '',
      unitPrice: 0,
      quantity: 1,
      discountOfPercent: 0,
      nonTaxable: false,
    });
  }

  private onItemDelete(index: number) {
    this.billData.items.splice(index, 1);
  }

  private onGroupChange(row: BillItemData) {
    const firstItem = this.masterItems.find((item) => item.groupType === row.groupType);
    if (firstItem) {
      row.itemId = firstItem.itemId;
    }
    this.onChangeBillItem(row);
  }

  private onChangeBillItem(row: BillItemData) {
    billUtil.refrectDetail(this.billItems, this.billData.billGradeYear, row);
  }
}
